import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { enGB } from "date-fns/locale/en-GB";
import { addDays, subDays } from "date-fns";
import "./AppDatePicker.css";

registerLocale("en-GB", enGB);

interface RangeDatePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  onChange: (dates: [Date | null, Date | null]) => void;
  minDaysSub: number;
  maxDaysAdd: number;
}

const RangeDatePicker: React.FC<RangeDatePickerProps> = ({
  startDate,
  endDate,
  onChange,
  minDaysSub,
  maxDaysAdd,
}) => {
  return (
    <DatePicker
      selectsRange
      startDate={startDate ?? undefined}
  endDate={endDate ?? undefined}
      onChange={onChange}
      isClearable
      placeholderText="Select date range"
      dateFormat="dd/MM/yyyy"
      minDate={subDays(new Date(), minDaysSub)}
      maxDate={addDays(new Date(), maxDaysAdd)}
      locale="en-GB"
      className="mr-2 px-4 py-1 pr-6 border rounded-[25px] h-[40px]"
    />
  );
};

export default RangeDatePicker;
